import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, message, Popconfirm } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { getSkills, createSkill, updateSkill, deleteSkill } from '../api';

const Skills = () => {
  const [skills, setSkills] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form] = Form.useForm();

  const fetchSkills = async () => {
    setLoading(true);
    const res = await getSkills();
    setLoading(false);
    if (res.success) {
      setSkills(res.data);
    } else {
      message.error(res.message || 'Failed to fetch skills');
    }
  };

  useEffect(() => {
    fetchSkills();
  }, []);

  const openModal = (record = null) => {
    setEditing(record);
    form.setFieldsValue(record ? { name: record.name } : { name: '' });
    setModalVisible(true);
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      let res;
      if (editing) {
        res = await updateSkill(editing.id, values);
      } else {
        res = await createSkill(values);
      }
      if (res.success) {
        message.success(editing ? 'Skill updated' : 'Skill created');
        setModalVisible(false);
        fetchSkills();
      } else {
        message.error(res.message || 'Operation failed');
      }
    } catch (err) {
      // Validation error
    }
  };

  const handleDelete = async (id) => {
    const res = await deleteSkill(id);
    if (res.success) {
      message.success('Skill deleted');
      fetchSkills();
    } else {
      message.error(res.message || 'Delete failed');
    }
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id' },
    { title: 'Name', dataIndex: 'name', key: 'name' },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Button
            size="small"
            icon={<EditOutlined />}
            style={{ marginRight: 8 }}
            onClick={() => openModal(record)}
            title="Edit"
          />
          <Popconfirm title="Are you sure to delete this skill?" onConfirm={() => handleDelete(record.id)} okText="Yes" cancelText="No">
            <Button size="small" icon={<DeleteOutlined />} danger title="Delete" />
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
        <h2>Skills</h2>
        <Button type="primary" icon={<PlusOutlined />} onClick={() => openModal()}>
          Add Skill
        </Button>
      </div>
      <Table columns={columns} dataSource={skills} loading={loading} rowKey="id" />
      <Modal
        title={editing ? 'Edit Skill' : 'Add Skill'}
        open={modalVisible}
        onOk={handleOk}
        onCancel={() => setModalVisible(false)}
      >
        <Form form={form} layout="vertical">
          <Form.Item name="name" label="Skill Name" rules={[{ required: true, message: 'Please enter skill name' }]}>
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Skills; 